import axios from "../../axiosDod.js";
import { createRequestSequence } from "../requestSequence";

const dodSmsListSeq = createRequestSequence();

const getDodSmsList = async ({ commit }, data) => {
  const params = {};

  const { search, on_page, page_number } = data;
  if (search) {
    params.search = search;
  }
  if (on_page) {
    params.limit = on_page;
  }
  if (page_number) {
    params.page = page_number;
  }
  const requestId = dodSmsListSeq.next();
  const smsList = await axios.get(`sms`, { params });
  if (!dodSmsListSeq.isLatest(requestId)) return;
  commit("SET_DOD_SMS_LIST", smsList.data);
};

const sendDodSms = async (_, data) => {
  try {
    const {
      senderPhoneNumber,
      text,
      type,
      recipientPhoneNumber,
      recipientsPhoneNumbers,
      selectedCustomersStatus,
      selectedEmployeesStatus,
    } = data;
    const body = {
      type,
      senderPhoneNumber,
      text,
    };
    if (type === "SINGLE") {
      body.recipientPhoneNumber = recipientPhoneNumber;
    }
    if (type === "SELECTED_PHONE_NUMBERS") {
      body.recipientsPhoneNumbers = recipientsPhoneNumbers;
    }
    if (type === "EMPLOYEES") {
      body.statusId = selectedEmployeesStatus;
    }
    if (type === "CUSTOMERS") {
      body.statusId = selectedCustomersStatus;
    }
    await axios.post(`sms`, body);
    return true;
  } catch (error) {
    return false;
  }
};

export default {
  getDodSmsList,
  sendDodSms,
};
